/**
 * Helpers — tuile portail « Paie » (Batch #14.251).
 * Le client saisit et reçoit ; aucun calcul ni montant de retenue n'est affiché.
 */
import axios from "axios";
import { toast } from "@/lib/toast";
import { API, portalHeaders } from "../helpers.js";
import { addDays } from "@/lib/format";
export { addDays };

export { API, portalHeaders };
export { Field, SectionCard, inputCls, isDemoResponse, today, addBtnCls, formActionsCls, cancelBtnCls, saveBtnCls, deleteBtnCls } from "../entreprise/_shared";

export const FREQ_LABELS = { weekly: "Hebdomadaire", biweekly: "Aux 2 semaines", monthly: "Mensuelle" };
export const FREQ_DAYS = { weekly: 7, biweekly: 14, monthly: 0 };
export const PAY_TYPES = { hourly: "Horaire", salary: "Salaire annuel" };
export const PAYMENT_METHODS = { deposit: "Dépôt direct", cheque: "Chèque" };
export const MONTHS_LONG = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const YEARS = [0, -1, -2].map((d) => new Date().getFullYear() + d);

export const RUN_CLIENT_STATUS = {
  open: { label: "En saisie", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  submitted: { label: "Soumise — en traitement", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  processed: { label: "Traitée", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export function ClientStatus({ status, testId }) {
  const s = RUN_CLIENT_STATUS[status] || RUN_CLIENT_STATUS.open;
  return <span className={`text-[10px] px-2 py-0.5 rounded-full border font-semibold whitespace-nowrap ${s.cls}`} data-testid={testId}>{s.label}</span>;
}

export const num = (v) => (v === "" || v === null || v === undefined ? 0 : Number(v) || 0);
export const fmtDate = (iso) => (iso ? new Date(iso.slice(0, 10) + "T00:00:00").toLocaleDateString("fr-CA", { day: "numeric", month: "long", year: "numeric" }) : "—");
export const err = (e, fallback = "Erreur") => toast.error(e?.response?.data?.detail || fallback);

/** Téléchargement authentifié (jeton portail) → blob → lien. */
export async function portalDownload(path, filename, setBusy) {
  setBusy?.(true);
  try {
    const r = await axios.get(`${API}${path}`, { headers: portalHeaders(), responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
    toast.success(`${filename} téléchargé`);
  } catch (e) {
    let msg = "Erreur de téléchargement";
    try { msg = JSON.parse(await e.response?.data?.text())?.detail || msg; } catch { /* blob non JSON */ }
    toast.error(msg);
  } finally {
    setBusy?.(false);
  }
}

/** Prochaine période suggérée d'après la dernière feuille de temps de même fréquence. */
export function nextPeriod(runs, frequency) {
  const last = runs.filter((r) => r.frequency === frequency).sort((a, b) => (a.period_end < b.period_end ? 1 : -1))[0];
  if (frequency === "monthly") {
    const d = last ? new Date(last.period_end + "T00:00:00") : new Date();
    if (last) d.setDate(d.getDate() + 1); else d.setDate(1);
    const start = d.toISOString().slice(0, 10);
    const end = new Date(d.getFullYear(), d.getMonth() + 1, 0).toISOString().slice(0, 10);
    return { period_start: start, period_end: end, pay_date: end };
  }
  const start = last ? addDays(last.period_end, 1) : new Date().toISOString().slice(0, 10);
  const end = addDays(start, FREQ_DAYS[frequency] - 1);
  return { period_start: start, period_end: end, pay_date: addDays(end, 5) };
}
